import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";

const perks = [
  "Acceso gratuito durante 3 meses al Mastermind.",
  "Sesiones “Tu Negocio a Examen”.",
  "Masterclasses online con expertas.",
  "Comunidad privada.",
  "Oportunidades de colaboración.",
  "Espacios de visibilidad y relacionamiento.",
  "Recursos formativos y contenidos de valor.",
  "Confidencialidad y entorno seguro entre mujeres líderes.",
];

const Mastermind = () => {
  return (
    <section
      id="mastermind"
      data-testid="mastermind-section"
      className="bg-[#63846F] text-[#FAF8F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-8 md:gap-14">
          <div className="col-span-12 lg:col-span-6">
            <Reveal>
              <Chapter number="08" label="Después del evento" tone="light" />
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#FAF8F3]">
                Tu entrada no termina
                <span className="italic"> el día del evento.</span>
              </h2>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-8 md:mt-10 font-sans text-base md:text-lg leading-relaxed text-[#FAF8F3]/85 max-w-xl">
                Lidera con Voz Propia continúa después de la jornada presencial
                a través del <em className="not-italic underline underline-offset-4 decoration-[#FAF8F3]/40">Mastermind</em>,
                un espacio de acompañamiento grupal durante tres meses diseñado
                para que el aprendizaje se convierta en acción, conexión y
                oportunidades.
              </p>
            </Reveal>
            <Reveal delay={240}>
              <blockquote className="mt-12 md:mt-16 border-l-2 border-[#FAF8F3]/70 pl-6 md:pl-8">
                <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-snug text-[#FAF8F3]">
                  El verdadero valor empieza cuando la sala se convierte en
                  comunidad.
                </p>
              </blockquote>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:pt-4">
            <ul className="border-t border-[#FAF8F3]/25">
              {perks.map((p, i) => (
                <Reveal
                  as="li"
                  key={i}
                  delay={i * 60}
                  className="border-b border-[#FAF8F3]/25 py-4 md:py-5 flex items-start gap-5"
                  data-testid={`mastermind-perk-${i}`}
                >
                  <span className="overline text-[#FAF8F3]/60 mt-2 w-8 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-sans text-base md:text-lg text-[#FAF8F3]/95 leading-snug">
                    {p}
                  </span>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mastermind;
